import { useMemo, useState } from "react";

import styled from "styled-components";

import { Table, TruncatedTextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import { CollapsibleSection } from "./CollapsibleSection";

const PAGE_SIZE = 5;

const COLUMN_CONFIG = [
    {
        dataIndex: "query" as const,
        key: "query",
        title: "",
        render: (value: string) => <TruncatedTextCell>{value}</TruncatedTextCell>,
    },
];

const StyledTableWrapper = styled.div`
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 4px;
    padding: 4px 16px;
    overflow: hidden;

    .ant-table-thead {
        display: none;
    }

`;

interface IWebSearchQueriesSectionProps {
    queries: string[];
}

interface IQueryRow {
    query: string;
    id: number;
}

export const WebSearchQueriesSection = ({ queries }: IWebSearchQueriesSectionProps) => {
    const [currentPage, setCurrentPage] = useState(1);

    const tableData = useMemo(
        () => queries?.map((query, index) => ({ query, id: index })) ?? [],
        [queries],
    );

    if (!queries || queries.length === 0) {
        return null;
    }

    return (
        <CollapsibleSection
            title={translate("llm.prompts.citations_side_panel.web_search_queries.title", {
                count: queries.length,
            })}
            defaultExpanded={false}
            margin="16px 0 0 0"
        >
            <StyledTableWrapper data-automation="prompts-side-panel-web-search-queries-table">
                <Table<IQueryRow>
                    rowHoverable={false}
                    bordersConfig={{ lastRowBorder: false }}
                    columnConfig={COLUMN_CONFIG}
                    data={tableData}
                    rowKey={(record: IQueryRow) => String(record.id)}
                    pagination={
                        queries.length > PAGE_SIZE
                            ? {
                                  pageSize: PAGE_SIZE,
                                  current: currentPage,
                                  onChange: (_pageSize: number, _total: number, page: number) =>
                                      setCurrentPage(page),
                              }
                            : undefined
                    }
                />
            </StyledTableWrapper>
        </CollapsibleSection>
    );
};
